import { createFileRoute } from '@tanstack/react-router';

import { ProjektyView } from '../../raporty/projekty/ProjektyView';

export const Route = createFileRoute('/raporty/projekty')({
  component: ProjektyView,
});
